import {getOneSchoolAllTeacherList,getOneSchoolDefaultPasswordInfo} from "@/api/exp/TeacherApi";

/**
 教师model
 */
class TeacherModel {
  // 获取一个学校所有的教师列表
  static async getOneSchoolAllTeacherList(schoolId) {
    let [result] = await getOneSchoolAllTeacherList(schoolId)
    if(result.code==20000){
      return result.data
    }else{
      return []
    }
  }

  // 获取一个学校所在学校的用户默认密码
  static async getOneSchoolDefaultPasswordInfo() {
    let [result] = await getOneSchoolDefaultPasswordInfo()
    if(result.code==20000){
      return result.data
    }else{
      return ""
    }
  }
}

export {TeacherModel}
